(function () {
  'use strict';

  var PRODUCTS = {
    puppyMini: 'natura-diet-puppy-junior-mini-hvalpefoder',
    puppyJunior: 'natura-diet-puppy-junior-hvalpefoder-op-til-8-maneder',
    puppyLarge: 'natura-diet-puppy-large-breed-hvalpefoder-op-til-18-maneder',
    dailyMini: 'natura-diet-daily-mini-hundefoder',
    daily: 'natura-diet-daily-hundefoder-komplet-hundefoder',
    dailyMaxi: 'natura-diet-daily-maxi-hundefoder',
    fishMini: 'natura-diet-fisk-og-ris-mini-hundefoder-3-kg',
    fish: 'natura-diet-fisk-og-ris-hundefoder',
    lambMini: 'natura-diet-lam-og-ris-mini-hundefoder',
    lamb: 'natura-diet-lam-og-ris-hundefoder',
    ibericoMini: 'natura-diet-mini-iberico-og-ris-hundefoder',
    iberico: 'natura-diet-iberico-og-ris-hundefoder',
    seniorMini: 'natura-diet-hundefoder-7-mini-500-g',
    senior: 'natura-diet-7-senior-hundefoder',
    light: 'natura-diet-light-10-kalorier-hundefoder',
    reducedMini: 'natura-diet-reduced-20-kalorier-mini-hundefoder',
    reduced: 'natura-diet-reduced-20-kalorier-hundefoder',
    grainFreeDuck: 'natura-diet-kornfri-hundefoder-komplet-hundefoder',
    grainFreeDuckMini: 'natura-diet-kornfri-and-og-sod-kartoffel-mini-hundefoder-komplet-hundefoder',
    grainFreeChicken: 'natura-diet-kornfri-kylling-og-groentsager-hundefoder-komplet-hundefoder'
  };


  var FEEDING_TABLES = {
    standardAdult: [
      [6, 110, 125],
      [8, 140, 160],
      [10, 175, 190],
      [12, 190, 200],
      [14, 215, 235],
      [18, 255, 285],
      [20, 275, 305],
      [22, 295, 330],
      [25, 320, 355],
      [30, 355, 390],
      [34, 385, 430],
      [38, 420, 465],
      [42, 450, 500],
      [45, 470, 660],
      [55, 580, 760],
      [65, 615, 860],
      [75, 680, 950],
      [90, 750, 1050]
    ],

    dailyMini: [
      [1, 30, 40],
      [2, 50, 55],
      [3, 60, 70],
      [4, 80, 95],
      [5, 100, 110],
      [6, 110, 125],
      [7, 130, 135],
      [8, 135, 150],
      [9, 150, 165],
      [10.5, 175, 200],
      [12.5, 175, 200],
      [15, 200, 245]
    ],

    fishMini: [
      [1, 25, 30],
      [2, 45, 50],
      [3, 60, 70],
      [4, 75, 85],
      [5, 90, 100],
      [6, 100, 115],
      [7, 115, 130],
      [8, 125, 145],
      [9, 130, 160],
      [10, 150, 170],
      [11, 160, 180],
      [12, 170, 195],
      [14, 215, 235],
      [18, 255, 285],
      [20, 275, 305]
    ],

    lambMini: [
      [1, 30, 40],
      [2, 50, 55],
      [3, 60, 70],
      [4, 80, 95],
      [5, 100, 110],
      [6, 110, 130],
      [7, 130, 135],
      [8, 135, 150],
      [9, 150, 165],
      [10.5, 160, 210],
      [12.5, 160, 210],
      [15, 210, 245]
    ],

    lambAdult: [
      [6, 110, 130],
      [10, 160, 190],
      [12, 190, 205],
      [14, 215, 235],
      [18, 215, 280],
      [20, 275, 305],
      [25, 320, 355],
      [30, 355, 390],
      [34, 390, 430],
      [38, 420, 465],
      [42, 450, 500],
      [45, 470, 660],
      [55, 580, 760],
      [65, 615, 860],
      [75, 680, 950],
      [90, 750, 1050]
    ],

    ibericoMini: [
      [1, 25, 30],
      [2, 40, 50],
      [3, 60, 65],
      [4, 70, 80],
      [5, 85, 95],
      [6, 95, 110],
      [7, 110, 125],
      [8, 120, 140],
      [9, 130, 150],
      [10, 140, 165]
    ],

    reducedMini: [
      [1, 25, 30],
      [2, 40, 50],
      [3, 55, 65],
      [4, 65, 80],
      [5, 80, 95],
      [6, 90, 110],
      [7, 100, 125],
      [8, 115, 135],
      [9, 125, 150],
      [10, 135, 160]
    ],

    grainFreeDuckMini: [
      [1, 25, 30],
      [2, 40, 50],
      [3, 55, 65],
      [4, 70, 80],
      [5, 80, 90],
      [6, 95, 110],
      [7, 105, 120],
      [8, 115, 135],
      [9, 130, 160],
      [10, 140, 160]
    ],

    grainFreeDuckAdult: [
      [11, 150, 170],
      [12, 160, 180],
      [14, 180, 200],
      [18, 210, 245],
      [20, 230, 265],
      [25, 275, 315],
      [30, 315, 360],
      [34, 350, 395],
      [38, 380, 430],
      [42, 405, 465],
      [45, 430, 490],
      [55, 500, 570],
      [65, 565, 645],
      [75, 639, 720],
      [90, 720, 820]
    ],

    seniorMini: [
      [1, 30, 35],
      [2, 50, 55],
      [3, 65, 75],
      [4, 80, 95],
      [5, 100, 110],
      [6, 110, 120],
      [7, 120, 130],
      [8, 130, 140],
      [9, 140, 150],
      [10, 155, 175],
      [12, 155, 175],
      [13, 165, 200],
      [15, 165, 200]
    ],

    seniorAdult: [
      [2, 50, 55],
      [4, 80, 90],
      [6, 110, 120],
      [10, 155, 175],
      [12, 165, 185],
      [14, 195, 215],
      [18, 220, 245],
      [20, 235, 265],
      [22, 250, 285],
      [25, 280, 315],
      [30, 305, 345],
      [34, 335, 375],
      [38, 365, 410],
      [42, 390, 440],
      [45, 430, 580],
      [55, 570, 650],
      [65, 600, 780],
      [75, 650, 830],
      [90, 720, 930]
    ]
  };


  var WEIGHT_RANGES = {
    'up-to-5': {
      min: 1,
      max: 5,
      label: 'Op til 5 kg'
    },

    '5-10': {
      min: 5,
      max: 10,
      label: '5–10 kg'
    },

    '11-15': {
      min: 11,
      max: 15,
      label: '11–15 kg'
    },

    '16-20': {
      min: 16,
      max: 20,
      label: '16–20 kg'
    },

    '21-30': {
      min: 21,
      max: 30,
      label: '21–30 kg'
    },

    '31-40': {
      min: 31,
      max: 40,
      label: '31–40 kg'
    },

    '41-50': {
      min: 41,
      max: 50,
      label: '41–50 kg'
    },

    '51-70': {
      min: 51,
      max: 70,
      label: '51–70 kg'
    },

    'over-70': {
      min: 70,
      max: 90,
      label: 'Over 70 kg',
      openEnded: true
    }
  };


  var PUPPY_AGE_POINTS = [
    2.5,
    4,
    6,
    8,
    10,
    12,
    14,
    16,
    21
  ];


  var PUPPY_JUNIOR_TABLE = [
    [2, [60, 60, 50, 50, null, null, null, null, null]],
    [4, [75, 90, 90, 85, null, null, null, null, null]],
    [6, [100, 120, 120, 115, 110, 105, null, null, null]],
    [8, [120, 150, 150, 145, 140, 135, null, null, null]],
    [10, [140, 170, 170, 165, 165, 160, null, null, null]],
    [12, [145, 175, 175, 170, 165, 160, null, null, null]],
    [14, [170, 220, 220, 215, 210, 205, null, null, null]],
    [18, [250, 260, 265, 255, 250, 245, 240, null, null]],
    [22, [260, 300, 305, 300, 290, 285, 280, null, null]],
    [25, [290, 325, 335, 330, 320, 315, 310, null, null]],
    [30, [290, 315, 425, 415, 405, 395, 395, 380, null]]
  ];


  var PUPPY_LARGE_TABLE = [
    [30, [null, 315, 425, 415, 405, 395, 395, 380, null]],
    [35, [null, 350, 470, 465, 455, 445, 440, 430, null]],
    [40, [null, 385, 520, 515, 500, 490, 480, 470, null]],
    [45, [null, 425, 565, 560, 550, 535, 520, 510, null]],
    [60, [null, 520, 615, 690, 675, 665, 660, 650, 635]],
    [75, [null, 545, 690, 720, 800, 780, 770, 760, 745]],
    [90, [null, 675, 925, 940, 920, 895, 885, 870, 840]]
  ];


  function calculateAge(birthDateValue) {
    var birthDate = new Date(
      birthDateValue + 'T00:00:00'
    );

    var today = new Date();

    var years =
      today.getFullYear() -
      birthDate.getFullYear();

    var months =
      today.getMonth() -
      birthDate.getMonth();

    if (
      today.getDate() <
      birthDate.getDate()
    ) {
      months--;
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return {
      years: years,
      months: months
    };
  }


  function formatAge(years, months) {
    var parts = [];

    if (years === 1) {
      parts.push('1 år');
    } else if (years > 1) {
      parts.push(years + ' år');
    }

    if (months === 1) {
      parts.push('1 måned');
    } else if (months > 1) {
      parts.push(months + ' måneder');
    }

    return parts.length
      ? parts.join(' og ')
      : 'under 1 måned';
  }


  function getTotalAgeMonths(years, months) {
    return (years * 12) + months;
  }


  function parseWeight(value) {
    return typeof value === 'string'
      ? Number(
          value.replace(',', '.')
        )
      : NaN;
  }


  function roundToNearestFive(value) {
    return Math.round(
      value / 5
    ) * 5;
  }


  function interpolateTable(
    table,
    weight,
    valueIndex
  ) {
    if (
      !Array.isArray(table) ||
      !table.length ||
      !Number.isFinite(weight)
    ) {
      return null;
    }

    if (
      weight < table[0][0] ||
      weight > table[table.length - 1][0]
    ) {
      return null;
    }

    for (
      var i = 0;
      i < table.length;
      i++
    ) {
      if (
        weight === table[i][0]
      ) {
        return table[i][valueIndex];
      }

      if (
        weight < table[i][0]
      ) {
        var lower =
          table[i - 1];

        var upper =
          table[i];

        if (
          !lower ||
          !upper
        ) {
          return null;
        }

        var lowerValue =
          lower[valueIndex];

        var upperValue =
          upper[valueIndex];

        if (
          !Number.isFinite(lowerValue) ||
          !Number.isFinite(upperValue)
        ) {
          return null;
        }

        var ratio =
          (
            weight -
            lower[0]
          ) /
          (
            upper[0] -
            lower[0]
          );

        return (
          lowerValue +
          (
            (
              upperValue -
              lowerValue
            ) *
            ratio
          )
        );
      }
    }

    return null;
  }


  function interpolatePuppyWeight(
    table,
    expectedAdultWeight,
    ageColumnIndex
  ) {
    if (
      !Array.isArray(table) ||
      !table.length ||
      !Number.isFinite(
        expectedAdultWeight
      ) ||
      ageColumnIndex < 0
    ) {
      return null;
    }

    if (
      expectedAdultWeight <
        table[0][0] ||
      expectedAdultWeight >
        table[table.length - 1][0]
    ) {
      return null;
    }

    for (
      var i = 0;
      i < table.length;
      i++
    ) {
      var rowWeight =
        table[i][0];

      var rowValue =
        table[i][1][ageColumnIndex];

      if (
        expectedAdultWeight ===
        rowWeight
      ) {
        return Number.isFinite(rowValue)
          ? rowValue
          : null;
      }

      if (
        expectedAdultWeight <
        rowWeight
      ) {
        var lower =
          table[i - 1];

        var upper =
          table[i];

        if (
          !lower ||
          !upper
        ) {
          return null;
        }

        var lowerValue =
          lower[1][ageColumnIndex];

        var upperValue =
          upper[1][ageColumnIndex];

        if (
          !Number.isFinite(lowerValue) ||
          !Number.isFinite(upperValue)
        ) {
          return null;
        }

        var ratio =
          (
            expectedAdultWeight -
            lower[0]
          ) /
          (
            upper[0] -
            lower[0]
          );

        return (
          lowerValue +
          (
            (
              upperValue -
              lowerValue
            ) *
            ratio
          )
        );
      }
    }

    return null;
  }


  function getPuppyAgeColumn(ageMonths) {
    if (
      !Number.isFinite(ageMonths) ||
      ageMonths < 2 ||
      ageMonths > 24
    ) {
      return -1;
    }

    if (
      ageMonths <= 3
    ) {
      return 0;
    }

    var nearestIndex = -1;
    var nearestDistance = Infinity;

    for (
      var i = 1;
      i < PUPPY_AGE_POINTS.length;
      i++
    ) {
      var distance =
        Math.abs(
          ageMonths -
          PUPPY_AGE_POINTS[i]
        );

      if (
        distance <
        nearestDistance
      ) {
        nearestDistance =
          distance;

        nearestIndex =
          i;
      }
    }

    return nearestIndex;
  }


  function parseVariantBagSize(title) {
    if (!title) {
      return null;
    }

    var text =
      String(title)
        .replace(/\u00a0/g, ' ')
        .trim();

    var kgMatch =
      text.match(
        /(\d+(?:[.,]\d+)?)\s*kg\b/i
      );

    if (kgMatch) {
      var kg =
        Number(
          kgMatch[1]
            .replace(',', '.')
        );

      if (
        Number.isFinite(kg) &&
        kg > 0
      ) {
        return {
          grams: kg * 1000,
          label:
            String(kg)
              .replace('.', ',') +
            ' kg'
        };
      }
    }

    var gramMatch =
      text.match(
        /(\d+(?:[.,]\d+)?)\s*g\b/i
      );

    if (gramMatch) {
      var grams =
        Number(
          gramMatch[1]
            .replace(',', '.')
        );

      if (
        Number.isFinite(grams) &&
        grams > 0
      ) {
        return {
          grams: grams,
          label:
            String(grams)
              .replace('.', ',') +
            ' g'
        };
      }
    }

    return null;
  }


  function getSelectedBagInfo(
    root,
    handle
  ) {
    if (
      !root ||
      !handle
    ) {
      return null;
    }

    var card =
      root.querySelector(
        '[data-fodermatch-product-card][data-fodermatch-product-handle="' +
        handle +
        '"]'
      );

    if (!card) {
      return null;
    }

    var select =
      card.querySelector(
        '[data-fodermatch-variant-select]'
      );

    if (
      !select ||
      !select.options ||
      !select.options.length
    ) {
      return null;
    }

    var option =
      select.options[
        select.selectedIndex
      ];

    if (!option) {
      return null;
    }

    var title =
      option.getAttribute(
        'data-fodermatch-variant-title'
      ) ||
      option.textContent ||
      '';

    return parseVariantBagSize(
      title
    );
  }


  function getSelectedQuantity(
    root,
    handle
  ) {
    if (
      !root ||
      !handle
    ) {
      return null;
    }

    var card =
      root.querySelector(
        '[data-fodermatch-product-card][data-fodermatch-product-handle="' +
        handle +
        '"]'
      );

    if (!card) {
      return null;
    }

    var input =
      card.querySelector(
        '[data-fodermatch-quantity]'
      );

    if (!input) {
      return 1;
    }

    var quantity =
      Number(input.value);

    if (
      !Number.isInteger(quantity) ||
      quantity < 1
    ) {
      return null;
    }

    return quantity;
  }


  function formatFoodWeight(grams) {
    if (
      !Number.isFinite(grams) ||
      grams <= 0
    ) {
      return '';
    }

    if (grams >= 1000) {
      var kg = grams / 1000;

      var roundedKg =
        Math.round(kg * 100) / 100;

      return String(roundedKg)
        .replace('.', ',') +
        ' kg';
    }

    return Math.round(grams) +
      ' g';
  }


  function getSelectedValues(
    root,
    selector
  ) {
    var values = [];

    root
      .querySelectorAll(
        selector + ':checked'
      )
      .forEach(
        function (input) {
          values.push(
            input.value
          );
        }
      );

    return values;
  }


  function recommendation(
    handles,
    reason,
    blocked
  ) {
    return {
      handles: handles || [],
      reason: reason || '',
      blocked: blocked === true
    };
  }


  function hasRealIntolerance(state) {
    return state.intolerances.some(
      function (value) {
        return value !== 'none';
      }
    );
  }


  function isMiniWeight(weight) {
    return (
      Number.isFinite(weight) &&
      weight <= 10
    );
  }


  function getRecommendation(state) {
    var name =
      state.dogName ||
      'Din hund';

    var referenceWeight =
      state.idealWeight;

    if (
      hasRealIntolerance(state)
    ) {
      return recommendation(
        [],
        name +
          ' er registreret med en eller flere intolerancer. ' +
          'Vi viser endnu ikke et produkt, før ingrediensfiltreringen ' +
          'er koblet til de rigtige produktingredienser.',
        true
      );
    }

    if (
      state.lifeStage === 'puppy'
    ) {
      if (
        state.expectedAdultWeight <= 10
      ) {
        return recommendation(
          [PRODUCTS.puppyMini],
          'Vi anbefaler Puppy Junior Mini ud fra alder og forventet voksenvægt.'
        );
      }

      if (
        state.expectedAdultWeight < 30
      ) {
        return recommendation(
          [PRODUCTS.puppyJunior],
          'Vi anbefaler Puppy Junior ud fra alder og forventet voksenvægt.'
        );
      }

      return recommendation(
        [PRODUCTS.puppyLarge],
        'Vi anbefaler Puppy Large Breed ud fra alder og forventet voksenvægt.'
      );
    }

    if (
      state.weightLoss === true
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.reducedMini
            : PRODUCTS.reduced
        ],
        'Da målet er vægttab, anbefaler vi Natura Diet Reduced -20%.'
      );
    }

    if (
      state.specialNeeds.indexOf(
        'digestive'
      ) !== -1
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.ibericoMini
            : PRODUCTS.iberico
        ],
        'Ved følsom fordøjelse prioriterer vi Natura Diet Iberico & Rice.'
      );
    }

    if (
      state.specialNeeds.indexOf(
        'low-allergen'
      ) !== -1
    ) {
      if (
        state.preference === 'fish'
      ) {
        return recommendation(
          [
            isMiniWeight(referenceWeight)
              ? PRODUCTS.fishMini
              : PRODUCTS.fish
          ],
          'Vi har kombineret behovet for lavt allergipotentiale med præferencen for fisk.'
        );
      }

      if (
        state.preference === 'lamb'
      ) {
        return recommendation(
          [
            isMiniWeight(referenceWeight)
              ? PRODUCTS.lambMini
              : PRODUCTS.lamb
          ],
          'Vi har kombineret behovet for lavt allergipotentiale med præferencen for lam.'
        );
      }

      return recommendation(
        isMiniWeight(referenceWeight)
          ? [
              PRODUCTS.fishMini,
              PRODUCTS.lambMini
            ]
          : [
              PRODUCTS.fish,
              PRODUCTS.lamb
            ],
        'Ved lavt allergipotentiale viser vi både Fish & Rice og Lamb & Rice som relevante muligheder.'
      );
    }

    if (
      state.neutered === true ||
      state.specialNeeds.indexOf(
        'weight-gain-tendency'
      ) !== -1
    ) {
      return recommendation(
        [PRODUCTS.light],
        'Vi anbefaler Natura Diet Light -10% til en voksen eller senior hund med tendens til vægtøgning eller efter sterilisation/kastration.'
      );
    }

    if (
      state.lifeStage === 'senior'
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.seniorMini
            : PRODUCTS.senior
        ],
        'Da hunden er 7 år eller ældre, anbefaler vi Natura Diet +7.'
      );
    }

    if (
      state.preference === 'fish'
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.fishMini
            : PRODUCTS.fish
        ],
        'Vi har matchet hunden med dens præference for fisk.'
      );
    }

    if (
      state.preference === 'lamb'
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.lambMini
            : PRODUCTS.lamb
        ],
        'Vi har matchet hunden med dens præference for lam.'
      );
    }

    if (
      state.preference === 'iberico'
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.ibericoMini
            : PRODUCTS.iberico
        ],
        'Vi har matchet hunden med dens præference for Iberico.'
      );
    }

    if (
      state.preference === 'duck' ||
      state.preference ===
        'grain-free-duck'
    ) {
      return recommendation(
        [
          isMiniWeight(referenceWeight)
            ? PRODUCTS.grainFreeDuckMini
            : PRODUCTS.grainFreeDuck
        ],
        'Vi har matchet hunden med Natura Diet Grain Free Duck & Sweet Potato.'
      );
    }

    if (
      state.preference ===
      'grain-free-chicken'
    ) {
      return recommendation(
        [PRODUCTS.grainFreeChicken],
        'Vi har matchet hunden med Natura Diet Grain Free Chicken & Vegs.'
      );
    }

    if (
      referenceWeight <= 10
    ) {
      return recommendation(
        [PRODUCTS.dailyMini],
        'Vi anbefaler Natura Diet Daily Food Mini som dagligt fuldfoder.'
      );
    }

    if (
      referenceWeight <= 30
    ) {
      return recommendation(
        [PRODUCTS.daily],
        'Vi anbefaler Natura Diet Daily Food som dagligt fuldfoder.'
      );
    }

    return recommendation(
      [PRODUCTS.dailyMaxi],
      'Vi anbefaler Natura Diet Daily Food Maxi ud fra hundens størrelse.'
    );
  }


  function getAdultFeedingProfile(
    handle
  ) {
    if (
      [
        PRODUCTS.daily,
        PRODUCTS.dailyMaxi,
        PRODUCTS.fish,
        PRODUCTS.iberico,
        PRODUCTS.light,
        PRODUCTS.reduced,
        PRODUCTS.grainFreeChicken
      ].indexOf(handle) !== -1
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.standardAdult
      };
    }

    if (
      handle === PRODUCTS.dailyMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.dailyMini
      };
    }

    if (
      handle === PRODUCTS.fishMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.fishMini
      };
    }

    if (
      handle === PRODUCTS.lambMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.lambMini
      };
    }

    if (
      handle === PRODUCTS.lamb
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.lambAdult
      };
    }

    if (
      handle === PRODUCTS.ibericoMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.ibericoMini
      };
    }

    if (
      handle === PRODUCTS.reducedMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.reducedMini
      };
    }

    if (
      handle === PRODUCTS.grainFreeDuckMini
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.grainFreeDuckMini
      };
    }

    if (
      handle === PRODUCTS.grainFreeDuck
    ) {
      return {
        type: 'adult',
        table:
          FEEDING_TABLES.grainFreeDuckAdult
      };
    }

    if (
      handle === PRODUCTS.seniorMini
    ) {
      return {
        type: 'senior',
        table:
          FEEDING_TABLES.seniorMini
      };
    }

    if (
      handle === PRODUCTS.senior
    ) {
      return {
        type: 'senior',
        table:
          FEEDING_TABLES.seniorAdult
      };
    }

    return null;
  }


  function getAdultValueIndex(
    profile,
    state
  ) {
    if (!profile) {
      return null;
    }

    if (
      profile.type === 'senior'
    ) {
      if (
        state.activity ===
        'very-high'
      ) {
        return null;
      }

      return 2;
    }

    return state.activity ===
      'very-high'
      ? 2
      : 1;
  }


  function isPuppyHandle(handle) {
    return (
      handle === PRODUCTS.puppyMini ||
      handle === PRODUCTS.puppyJunior ||
      handle === PRODUCTS.puppyLarge
    );
  }


  function calculateFeedingGrams(
    state,
    handle
  ) {
    if (!handle) {
      return null;
    }

    if (
      isPuppyHandle(handle)
    ) {
      if (
        !Number.isFinite(
          state.expectedAdultWeight
        ) ||
        !Number.isFinite(
          state.ageTotalMonths
        )
      ) {
        return null;
      }

      var ageColumn =
        getPuppyAgeColumn(
          state.ageTotalMonths
        );

      if (
        ageColumn < 0
      ) {
        return null;
      }

      var puppyTable =
        handle === PRODUCTS.puppyLarge
          ? PUPPY_LARGE_TABLE
          : PUPPY_JUNIOR_TABLE;

      var puppyGrams =
        interpolatePuppyWeight(
          puppyTable,
          state.expectedAdultWeight,
          ageColumn
        );

      return Number.isFinite(
        puppyGrams
      )
        ? roundToNearestFive(
            puppyGrams
          )
        : null;
    }

    if (
      !Number.isFinite(
        state.currentWeight
      )
    ) {
      return null;
    }

    var profile =
      getAdultFeedingProfile(
        handle
      );

    var valueIndex =
      getAdultValueIndex(
        profile,
        state
      );

    if (
      !profile ||
      valueIndex === null
    ) {
      return null;
    }

    var grams =
      interpolateTable(
        profile.table,
        state.currentWeight,
        valueIndex
      );

    return Number.isFinite(grams)
      ? roundToNearestFive(grams)
      : null;
  }


  function calculateFeedingRange(
    state,
    handle
  ) {
    if (
      !handle ||
      !state.currentWeightRange
    ) {
      return null;
    }

    if (
      isPuppyHandle(handle)
    ) {
      return null;
    }

    var range =
      WEIGHT_RANGES[
        state.currentWeightRange
      ];

    var profile =
      getAdultFeedingProfile(
        handle
      );

    var valueIndex =
      getAdultValueIndex(
        profile,
        state
      );

    if (
      !range ||
      !profile ||
      valueIndex === null
    ) {
      return null;
    }

    var tableMin =
      profile.table[0][0];

    var tableMax =
      profile.table[
        profile.table.length - 1
      ][0];

    var minWeight =
      Math.max(
        range.min,
        tableMin
      );

    var maxWeight =
      Math.min(
        range.max,
        tableMax
      );

    if (
      minWeight > maxWeight
    ) {
      return null;
    }

    var minGrams =
      interpolateTable(
        profile.table,
        minWeight,
        valueIndex
      );

    var maxGrams =
      interpolateTable(
        profile.table,
        maxWeight,
        valueIndex
      );

    if (
      !Number.isFinite(minGrams) ||
      !Number.isFinite(maxGrams)
    ) {
      return null;
    }

    minGrams =
      roundToNearestFive(
        minGrams
      );

    maxGrams =
      roundToNearestFive(
        maxGrams
      );

    if (
      minGrams > maxGrams
    ) {
      var swap =
        minGrams;

      minGrams =
        maxGrams;

      maxGrams =
        swap;
    }

    return {
      minGrams: minGrams,
      maxGrams: maxGrams,
      minWeight: minWeight,
      maxWeight: maxWeight,
      label: range.label,
      openEnded:
        range.openEnded === true
    };
  }


  function showCards(
    root,
    handles
  ) {
    var productsContainer =
      root.querySelector(
        '[data-fodermatch-result-products]'
      );

    var cards =
      root.querySelectorAll(
        '[data-fodermatch-product-card]'
      );

    cards.forEach(
      function (card) {
        card.hidden = true;
      }
    );

    if (
      !productsContainer
    ) {
      return;
    }

    handles.forEach(
      function (handle) {
        var card =
          root.querySelector(
            '[data-fodermatch-product-card][data-fodermatch-product-handle="' +
            handle +
            '"]'
          );

        if (!card) {
          return;
        }

        card.hidden = false;

        productsContainer.appendChild(
          card
        );
      }
    );
  }


  function setBagDaysExact(
    root,
    handle,
    gramsPerDay
  ) {
    var bagDays =
      root.querySelector(
        '[data-fodermatch-result-bag-days]'
      );

    if (!bagDays) {
      return;
    }

    bagDays.textContent = '';

    var bag =
      getSelectedBagInfo(
        root,
        handle
      );

    var quantity =
      getSelectedQuantity(
        root,
        handle
      );

    if (
      !bag ||
      !Number.isInteger(quantity) ||
      quantity < 1 ||
      !Number.isFinite(
        gramsPerDay
      ) ||
      gramsPerDay <= 0
    ) {
      return;
    }

    var totalGrams =
      bag.grams *
      quantity;

    var days =
      Math.max(
        1,
        Math.round(
          totalGrams /
          gramsPerDay
        )
      );

    if (quantity === 1) {
      bagDays.textContent =
        'Den valgte pose på ' +
        bag.label +
        ' rækker ca. ' +
        days +
        (
          days === 1
            ? ' dag.'
            : ' dage.'
        );

      return;
    }

    bagDays.textContent =
      quantity +
      ' poser × ' +
      bag.label +
      ' (' +
      formatFoodWeight(
        totalGrams
      ) +
      ' i alt) rækker ca. ' +
      days +
      (
        days === 1
          ? ' dag.'
          : ' dage.'
      );
  }


  function setBagDaysRange(
    root,
    handle,
    minGrams,
    maxGrams
  ) {
    var bagDays =
      root.querySelector(
        '[data-fodermatch-result-bag-days]'
      );

    if (!bagDays) {
      return;
    }

    bagDays.textContent = '';

    var bag =
      getSelectedBagInfo(
        root,
        handle
      );

    var quantity =
      getSelectedQuantity(
        root,
        handle
      );

    if (
      !bag ||
      !Number.isInteger(quantity) ||
      quantity < 1 ||
      !Number.isFinite(minGrams) ||
      !Number.isFinite(maxGrams) ||
      minGrams <= 0 ||
      maxGrams <= 0
    ) {
      return;
    }

    var totalGrams =
      bag.grams *
      quantity;

    var shortest =
      Math.max(
        1,
        Math.round(
          totalGrams /
          maxGrams
        )
      );

    var longest =
      Math.max(
        1,
        Math.round(
          totalGrams /
          minGrams
        )
      );

    if (
      shortest > longest
    ) {
      var swap = shortest;
      shortest = longest;
      longest = swap;
    }

    var selectionText =
      quantity === 1
        ? 'Den valgte pose på ' +
          bag.label
        : quantity +
          ' poser × ' +
          bag.label +
          ' (' +
          formatFoodWeight(
            totalGrams
          ) +
          ' i alt)';

    if (
      shortest === longest
    ) {
      bagDays.textContent =
        selectionText +
        ' rækker ca. ' +
        shortest +
        (
          shortest === 1
            ? ' dag.'
            : ' dage.'
        );

      return;
    }

    bagDays.textContent =
      selectionText +
      ' rækker ca. ' +
      shortest +
      '–' +
      longest +
      ' dage, afhængigt af hundens præcise vægt.';
  }


  function renderFeeding(
    root,
    state,
    result
  ) {
    var feedingBox =
      root.querySelector(
        '[data-fodermatch-result-feeding]'
      );

    var gramsDay =
      root.querySelector(
        '[data-fodermatch-result-grams-day]'
      );

    var gramsMeal =
      root.querySelector(
        '[data-fodermatch-result-grams-meal]'
      );

    var bagDays =
      root.querySelector(
        '[data-fodermatch-result-bag-days]'
      );

    var deliveryInterval =
      root.querySelector(
        '[data-fodermatch-result-delivery-interval]'
      );

    if (
      !feedingBox ||
      !gramsDay
    ) {
      return;
    }

    feedingBox.hidden = true;

    gramsDay.textContent = '–';

    if (gramsMeal) {
      gramsMeal.textContent = '';
    }

    if (bagDays) {
      bagDays.textContent = '';
    }

    if (deliveryInterval) {
      deliveryInterval.textContent = '';
    }

    if (
      !result ||
      result.blocked ||
      result.handles.length !== 1
    ) {
      return;
    }

    var handle =
      result.handles[0];

    if (
      isPuppyHandle(handle)
    ) {
      if (
        !Number.isFinite(
          state.currentWeight
        )
      ) {
        return;
      }

      var puppyGrams =
        calculateFeedingGrams(
          state,
          handle
        );

      if (
        !Number.isFinite(
          puppyGrams
        )
      ) {
        return;
      }

      gramsDay.textContent =
        String(puppyGrams);

      if (gramsMeal) {
        gramsMeal.textContent =
          'Vejledende startmængde ud fra alder og forventet voksenvægt.';
      }

      setBagDaysExact(
        root,
        handle,
        puppyGrams
      );

      feedingBox.hidden = false;

      return;
    }

    if (
      Number.isFinite(
        state.currentWeight
      )
    ) {
      var grams =
        calculateFeedingGrams(
          state,
          handle
        );

      if (
        !Number.isFinite(
          grams
        )
      ) {
        return;
      }

      gramsDay.textContent =
        String(grams);

      if (gramsMeal) {
        gramsMeal.textContent =
          'Vejledende startmængde ud fra Natura Diets fodertabel.';
      }

      setBagDaysExact(
        root,
        handle,
        grams
      );

      feedingBox.hidden = false;

      return;
    }

    if (
      state.currentWeightRange
    ) {
      var rangeResult =
        calculateFeedingRange(
          state,
          handle
        );

      if (!rangeResult) {
        return;
      }

      gramsDay.textContent =
        rangeResult.minGrams ===
        rangeResult.maxGrams
          ? 'ca. ' +
            String(
              rangeResult.minGrams
            )
          : 'ca. ' +
            rangeResult.minGrams +
            '–' +
            rangeResult.maxGrams;

      if (gramsMeal) {
        if (
          rangeResult.openEnded
        ) {
          gramsMeal.textContent =
            'Vejledende interval for ca. ' +
            rangeResult.minWeight +
            '–' +
            rangeResult.maxWeight +
            ' kg. Ved en hund over ' +
            rangeResult.maxWeight +
            ' kg skal den præcise vægt bruges for en sikker beregning.';
        } else {
          gramsMeal.textContent =
            'Vejledende interval for vægtgruppen ' +
            rangeResult.label +
            '. Den præcise dagsration afhænger af hundens faktiske vægt.';
        }
      }

      setBagDaysRange(
        root,
        handle,
        rangeResult.minGrams,
        rangeResult.maxGrams
      );

      feedingBox.hidden = false;
    }
  }


  function initFoderMatch(scope) {
    var container =
      scope ||
      document;

    var roots =
      container.querySelectorAll(
        '[data-fodermatch-root]'
      );

    roots.forEach(
      function (root) {
        if (
          root.getAttribute(
            'data-fodermatch-initialized'
          ) === 'true'
        ) {
          return;
        }

        root.setAttribute(
          'data-fodermatch-initialized',
          'true'
        );

        var state = {
          dogName: '',
          birthDate: '',
          approximateAge: false,
          ageYears: null,
          ageMonths: null,
          ageTotalMonths: null,
          lifeStage: '',
          expectedAdultWeight: null,
          idealWeight: null,
          currentWeight: null,
          currentWeightRange: '',
          bodyCondition: '',
          weightLoss: null,
          neutered: null,
          activity: 'normal',
          specialNeeds: [],
          intolerances: [],
          intoleranceOther: '',
          preference: ''
        };

        var currentResult = null;

        var startScreen =
          root.querySelector(
            '[data-fodermatch-start]'
          );

        var startButton =
          root.querySelector(
            '[data-fodermatch-start-button]'
          );

        var nameStep =
          root.querySelector(
            '[data-fodermatch-step="name"]'
          );

        var nameInput =
          root.querySelector(
            '[data-fodermatch-dog-name]'
          );

        var nameContinueButton =
          root.querySelector(
            '[data-fodermatch-name-continue]'
          );

        var birthdateStep =
          root.querySelector(
            '[data-fodermatch-step="birthdate"]'
          );

        var birthdateHeading =
          root.querySelector(
            '[data-fodermatch-birthdate-heading]'
          );

        var birthdateInput =
          root.querySelector(
            '[data-fodermatch-birthdate]'
          );

        var birthdateContinueButton =
          root.querySelector(
            '[data-fodermatch-birthdate-continue]'
          );

        var birthdateUnknownButton =
          root.querySelector(
            '[data-fodermatch-birthdate-unknown]'
          );

        var ageResult =
          root.querySelector(
            '[data-fodermatch-age-result]'
          );

        var approxAgeStep =
          root.querySelector(
            '[data-fodermatch-step="approx-age"]'
          );

        var approxAgeHeading =
          root.querySelector(
            '[data-fodermatch-approx-age-heading]'
          );

        var approxAgeYearsInput =
          root.querySelector(
            '[data-fodermatch-approx-age-years]'
          );

        var approxAgeMonthsInput =
          root.querySelector(
            '[data-fodermatch-approx-age-months]'
          );

        var approxAgeContinueButton =
          root.querySelector(
            '[data-fodermatch-approx-age-continue]'
          );

        var approxAgeBackButton =
          root.querySelector(
            '[data-fodermatch-approx-age-back]'
          );

        var adultWeightStep =
          root.querySelector(
            '[data-fodermatch-step="adult-weight"]'
          );

        var adultWeightHeading =
          root.querySelector(
            '[data-fodermatch-adult-weight-heading]'
          );

        var adultWeightInput =
          root.querySelector(
            '[data-fodermatch-adult-weight]'
          );

        var adultWeightContinueButton =
          root.querySelector(
            '[data-fodermatch-adult-weight-continue]'
          );

        var idealWeightStep =
          root.querySelector(
            '[data-fodermatch-step="ideal-weight"]'
          );

        var idealWeightHeading =
          root.querySelector(
            '[data-fodermatch-ideal-weight-heading]'
          );

        var idealWeightInput =
          root.querySelector(
            '[data-fodermatch-ideal-weight]'
          );

        var idealWeightContinueButton =
          root.querySelector(
            '[data-fodermatch-ideal-weight-continue]'
          );

        var currentWeightStep =
          root.querySelector(
            '[data-fodermatch-step="current-weight"]'
          );

        var currentWeightHeading =
          root.querySelector(
            '[data-fodermatch-current-weight-heading]'
          );

        var currentWeightInput =
          root.querySelector(
            '[data-fodermatch-current-weight]'
          );

        var currentWeightContinueButton =
          root.querySelector(
            '[data-fodermatch-current-weight-continue]'
          );

        var currentWeightUnknownButton =
          root.querySelector(
            '[data-fodermatch-current-weight-unknown]'
          );

        var weightRangeStep =
          root.querySelector(
            '[data-fodermatch-step="weight-range"]'
          );

        var weightRangeHeading =
          root.querySelector(
            '[data-fodermatch-weight-range-heading]'
          );

        var weightRangeInputs =
          root.querySelectorAll(
            '[data-fodermatch-weight-range]'
          );

        var weightRangeContinueButton =
          root.querySelector(
            '[data-fodermatch-weight-range-continue]'
          );

        var weightRangeBackButton =
          root.querySelector(
            '[data-fodermatch-weight-range-back]'
          );

        var bodyConditionStep =
          root.querySelector(
            '[data-fodermatch-step="body-condition"]'
          );

        var bodyConditionHeading =
          root.querySelector(
            '[data-fodermatch-body-condition-heading]'
          );

        var bodyConditionInputs =
          root.querySelectorAll(
            '[data-fodermatch-body-condition]'
          );

        var bodyConditionContinueButton =
          root.querySelector(
            '[data-fodermatch-body-condition-continue]'
          );

        var weightLossStep =
          root.querySelector(
            '[data-fodermatch-step="weight-loss"]'
          );

        var weightLossHeading =
          root.querySelector(
            '[data-fodermatch-weight-loss-heading]'
          );

        var weightLossInputs =
          root.querySelectorAll(
            '[data-fodermatch-weight-loss]'
          );

        var weightLossContinueButton =
          root.querySelector(
            '[data-fodermatch-weight-loss-continue]'
          );

        var neuteredStep =
          root.querySelector(
            '[data-fodermatch-step="neutered"]'
          );

        var neuteredHeading =
          root.querySelector(
            '[data-fodermatch-neutered-heading]'
          );

        var neuteredInputs =
          root.querySelectorAll(
            '[data-fodermatch-neutered]'
          );

        var neuteredContinueButton =
          root.querySelector(
            '[data-fodermatch-neutered-continue]'
          );

        var activityStep =
          root.querySelector(
            '[data-fodermatch-step="activity"]'
          );

        var activityHeading =
          root.querySelector(
            '[data-fodermatch-activity-heading]'
          );

        var activityInputs =
          root.querySelectorAll(
            '[data-fodermatch-activity]'
          );

        var activityContinueButton =
          root.querySelector(
            '[data-fodermatch-activity-continue]'
          );

        var specialNeedsStep =
          root.querySelector(
            '[data-fodermatch-step="special-needs"]'
          );

        var specialNeedsHeading =
          root.querySelector(
            '[data-fodermatch-special-needs-heading]'
          );

        var specialNeedsInputs =
          root.querySelectorAll(
            '[data-fodermatch-special-need]'
          );

        var specialNeedsNone =
          root.querySelector(
            '[data-fodermatch-special-need-none]'
          );

        var specialNeedsContinueButton =
          root.querySelector(
            '[data-fodermatch-special-needs-continue]'
          );

        var intolerancesStep =
          root.querySelector(
            '[data-fodermatch-step="intolerances"]'
          );

        var intolerancesHeading =
          root.querySelector(
            '[data-fodermatch-intolerances-heading]'
          );

        var intoleranceInputs =
          root.querySelectorAll(
            '[data-fodermatch-intolerance]'
          );

        var intoleranceNone =
          root.querySelector(
            '[data-fodermatch-intolerance-none]'
          );

        var intoleranceOther =
          root.querySelector(
            '[data-fodermatch-intolerance-other]'
          );

        var intoleranceOtherField =
          root.querySelector(
            '[data-fodermatch-intolerance-other-field]'
          );

        var intoleranceOtherText =
          root.querySelector(
            '[data-fodermatch-intolerance-other-text]'
          );

        var intolerancesContinueButton =
          root.querySelector(
            '[data-fodermatch-intolerances-continue]'
          );

        var preferenceStep =
          root.querySelector(
            '[data-fodermatch-step="preference"]'
          );

        var preferenceHeading =
          root.querySelector(
            '[data-fodermatch-preference-heading]'
          );

        var preferenceInputs =
          root.querySelectorAll(
            '[data-fodermatch-preference]'
          );

        var preferenceContinueButton =
          root.querySelector(
            '[data-fodermatch-preference-continue]'
          );

        var resultStep =
          root.querySelector(
            '[data-fodermatch-step="result"]'
          );

        var resultHeading =
          root.querySelector(
            '[data-fodermatch-result-heading]'
          );

        var resultReason =
          root.querySelector(
            '[data-fodermatch-result-reason]'
          );

        var fitHeadings =
          root.querySelectorAll(
            '[data-fodermatch-fit-heading]'
          );

        var status =
          root.querySelector(
            '[data-fodermatch-status]'
          );

        var variantSelects =
          root.querySelectorAll(
            '[data-fodermatch-variant-select]'
          );

        var quantityInputs =
          root.querySelectorAll(
            '[data-fodermatch-quantity]'
          );


        function setStatus(text) {
          if (status) {
            status.textContent = text;
          }
        }


        function clearBirthdateResult() {
          if (ageResult) {
            ageResult.textContent = '';
            ageResult.hidden = true;
          }
        }


        function setAgeState(
          years,
          months
        ) {
          state.ageYears = years;
          state.ageMonths = months;
          state.ageTotalMonths =
            getTotalAgeMonths(
              years,
              months
            );
        }


        function showStep(
          currentStep,
          nextStep
        ) {
          if (currentStep) {
            currentStep.hidden = true;
          }

          if (nextStep) {
            nextStep.hidden = false;
          }
        }


        function showWeightLossStep(
          currentStep
        ) {
          showStep(
            currentStep,
            weightLossStep
          );

          if (
            weightLossHeading
          ) {
            weightLossHeading.textContent =
              'Skal ' +
              state.dogName +
              ' ned i vægt?';
          }
        }


        function showBodyConditionStep(
          currentStep
        ) {
          showStep(
            currentStep,
            bodyConditionStep
          );

          if (
            bodyConditionHeading
          ) {
            bodyConditionHeading.textContent =
              'Hvordan vil du beskrive ' +
              state.dogName +
              's kropsform?';
          }
        }


        function showCurrentWeightStep(
          currentStep
        ) {
          showStep(
            currentStep,
            currentWeightStep
          );

          if (
            currentWeightHeading
          ) {
            currentWeightHeading.textContent =
              'Hvad vejer ' +
              state.dogName +
              ' lige nu?';
          }

          if (
            currentWeightInput
          ) {
            currentWeightInput.focus();
          }
        }


        function showIdealWeightStep(
          currentStep
        ) {
          showStep(
            currentStep,
            idealWeightStep
          );

          if (
            idealWeightHeading
          ) {
            idealWeightHeading.textContent =
              'Hvad er ' +
              state.dogName +
              's idealvægt?';
          }

          if (
            idealWeightInput
          ) {
            idealWeightInput.focus();
          }
        }


        function routeAfterAge(
          currentStep
        ) {
          if (
            state.ageTotalMonths < 14
          ) {
            showStep(
              currentStep,
              adultWeightStep
            );

            if (
              adultWeightHeading
            ) {
              adultWeightHeading.textContent =
                'Hvad forventer du, ' +
                state.dogName +
                ' vejer som voksen?';
            }

            if (
              state.ageTotalMonths < 12
            ) {
              setStatus(
                state.dogName +
                ' er under 12 måneder og behandles derfor som hvalp.'
              );
            } else {
              setStatus(
                state.dogName +
                ' er 12–13 måneder. Forventet voksenvægt afgør nu, om hvalpeperioden fortsætter.'
              );
            }

            if (
              adultWeightInput
            ) {
              adultWeightInput.focus();
            }

            return;
          }

          if (
            state.ageTotalMonths >= 84
          ) {
            state.lifeStage = 'senior';
          } else {
            state.lifeStage = 'adult';
          }

          showIdealWeightStep(
            currentStep
          );
        }


        function validateApproxAge() {
          if (
            !approxAgeYearsInput ||
            !approxAgeMonthsInput ||
            !approxAgeContinueButton
          ) {
            return;
          }

          var yearsValue =
            approxAgeYearsInput
              .value
              .trim();

          var monthsValue =
            approxAgeMonthsInput
              .value
              .trim();

          if (
            yearsValue === '' ||
            monthsValue === ''
          ) {
            approxAgeContinueButton.disabled =
              true;

            return;
          }

          var years =
            Number(yearsValue);

          var months =
            Number(monthsValue);

          approxAgeContinueButton.disabled =
            !(
              Number.isInteger(years) &&
              Number.isInteger(months) &&
              years >= 0 &&
              years <= 30 &&
              months >= 0 &&
              months <= 11 &&
              (
                years > 0 ||
                months > 0
              )
            );
        }


        function validateWeightInput(
          input,
          button,
          min,
          max
        ) {
          if (
            !input ||
            !button
          ) {
            return;
          }

          var weight =
            parseWeight(
              input.value
            );

          button.disabled =
            !(
              Number.isFinite(weight) &&
              weight >= min &&
              weight <= max
            );
        }


        function validateSpecialNeeds() {
          if (
            specialNeedsContinueButton
          ) {
            specialNeedsContinueButton.disabled =
              root.querySelectorAll(
                '[data-fodermatch-special-need]:checked'
              ).length === 0;
          }
        }


        function validateIntolerances() {
          if (
            !intolerancesContinueButton
          ) {
            return;
          }

          var checked =
            root.querySelectorAll(
              '[data-fodermatch-intolerance]:checked'
            );

          if (!checked.length) {
            intolerancesContinueButton.disabled =
              true;

            return;
          }

          if (
            intoleranceOther &&
            intoleranceOther.checked
          ) {
            var text =
              intoleranceOtherText
                ? intoleranceOtherText
                    .value
                    .trim()
                : '';

            intolerancesContinueButton.disabled =
              text.length === 0;

            return;
          }

          intolerancesContinueButton.disabled =
            false;
        }


        function renderResult() {
          var result =
            getRecommendation(
              state
            );

          currentResult =
            result;

          showCards(
            root,
            result.handles
          );

          renderFeeding(
            root,
            state,
            result
          );

          if (
            resultHeading
          ) {
            resultHeading.textContent =
              result.blocked
                ? 'Vi mangler en sikker match til ' +
                  state.dogName
                : 'Vi har fundet foder til ' +
                  state.dogName;
          }

          if (
            resultReason
          ) {
            resultReason.textContent =
              result.reason;
          }

          fitHeadings.forEach(
            function (heading) {
              heading.textContent =
                'Hvorfor passer dette foder til ' +
                state.dogName +
                '?';
            }
          );

          showStep(
            preferenceStep,
            resultStep
          );

          setStatus(
            result.blocked
              ? 'Produktvisning er stoppet, fordi der er registreret intolerance.'
              : 'FoderMatch er gennemført for ' +
                state.dogName +
                '.'
          );
        }


        variantSelects.forEach(
          function (select) {
            select.addEventListener(
              'change',
              function () {
                if (
                  currentResult
                ) {
                  renderFeeding(
                    root,
                    state,
                    currentResult
                  );
                }
              }
            );
          }
        );


        quantityInputs.forEach(
          function (input) {
            function updateQuantityCalculation() {
              if (
                currentResult
              ) {
                renderFeeding(
                  root,
                  state,
                  currentResult
                );
              }
            }

            input.addEventListener(
              'input',
              updateQuantityCalculation
            );

            input.addEventListener(
              'change',
              updateQuantityCalculation
            );
          }
        );


        if (
          birthdateInput
        ) {
          var today =
            new Date();

          birthdateInput.max =
            today.getFullYear() +
            '-' +
            String(
              today.getMonth() + 1
            ).padStart(2, '0') +
            '-' +
            String(
              today.getDate()
            ).padStart(2, '0');
        }


        setStatus(
          'FoderMatch er klar.'
        );


        if (
          startButton &&
          startScreen &&
          nameStep
        ) {
          startButton.addEventListener(
            'click',
            function () {
              startScreen.hidden = true;
              nameStep.hidden = false;

              if (
                nameInput
              ) {
                nameInput.focus();
              }
            }
          );
        }


        if (
          nameInput &&
          nameContinueButton
        ) {
          nameInput.addEventListener(
            'input',
            function () {
              nameContinueButton.disabled =
                nameInput
                  .value
                  .trim()
                  .length === 0;
            }
          );
        }


        if (
          nameContinueButton &&
          nameInput &&
          nameStep &&
          birthdateStep
        ) {
          nameContinueButton.addEventListener(
            'click',
            function () {
              var dogName =
                nameInput
                  .value
                  .trim();

              if (!dogName) {
                return;
              }

              state.dogName =
                dogName;

              showStep(
                nameStep,
                birthdateStep
              );

              if (
                birthdateHeading
              ) {
                birthdateHeading.textContent =
                  'Hvornår er ' +
                  state.dogName +
                  ' født?';
              }

              if (
                birthdateInput
              ) {
                birthdateInput.focus();
              }
            }
          );
        }


        if (
          birthdateInput &&
          birthdateContinueButton
        ) {
          birthdateInput.addEventListener(
            'input',
            function () {
              clearBirthdateResult();

              var value =
                birthdateInput.value;

              if (!value) {
                birthdateContinueButton.disabled =
                  true;

                return;
              }

              var selectedDate =
                new Date(
                  value +
                  'T00:00:00'
                );

              var today =
                new Date();

              selectedDate.setHours(
                0,
                0,
                0,
                0
              );

              today.setHours(
                0,
                0,
                0,
                0
              );

              birthdateContinueButton.disabled =
                selectedDate > today;
            }
          );
        }


        if (
          birthdateContinueButton &&
          birthdateInput &&
          ageResult
        ) {
          birthdateContinueButton.addEventListener(
            'click',
            function () {
              var birthDateValue =
                birthdateInput.value;

              if (
                !birthDateValue
              ) {
                return;
              }

              var age =
                calculateAge(
                  birthDateValue
                );

              state.birthDate =
                birthDateValue;

              state.approximateAge =
                false;

              setAgeState(
                age.years,
                age.months
              );

              ageResult.textContent =
                state.dogName +
                ' er ' +
                formatAge(
                  age.years,
                  age.months
                ) +
                ' gammel.';

              ageResult.hidden =
                false;

              routeAfterAge(
                birthdateStep
              );
            }
          );
        }


        if (
          birthdateUnknownButton &&
          birthdateStep &&
          approxAgeStep
        ) {
          birthdateUnknownButton.addEventListener(
            'click',
            function () {
              clearBirthdateResult();

              showStep(
                birthdateStep,
                approxAgeStep
              );

              if (
                approxAgeHeading
              ) {
                approxAgeHeading.textContent =
                  'Hvor gammel er ' +
                  state.dogName +
                  ' cirka?';
              }

              if (
                approxAgeYearsInput
              ) {
                approxAgeYearsInput.focus();
              }
            }
          );
        }


        if (
          approxAgeYearsInput
        ) {
          approxAgeYearsInput.addEventListener(
            'input',
            validateApproxAge
          );
        }


        if (
          approxAgeMonthsInput
        ) {
          approxAgeMonthsInput.addEventListener(
            'input',
            validateApproxAge
          );
        }


        if (
          approxAgeContinueButton &&
          approxAgeYearsInput &&
          approxAgeMonthsInput
        ) {
          approxAgeContinueButton.addEventListener(
            'click',
            function () {
              state.birthDate = '';
              state.approximateAge =
                true;

              setAgeState(
                Number(
                  approxAgeYearsInput.value
                ),
                Number(
                  approxAgeMonthsInput.value
                )
              );

              clearBirthdateResult();

              routeAfterAge(
                approxAgeStep
              );
            }
          );
        }


        if (
          approxAgeBackButton &&
          approxAgeStep &&
          birthdateStep
        ) {
          approxAgeBackButton.addEventListener(
            'click',
            function () {
              showStep(
                approxAgeStep,
                birthdateStep
              );

              clearBirthdateResult();

              if (
                birthdateInput
              ) {
                birthdateInput.focus();
              }
            }
          );
        }


        if (
          adultWeightInput
        ) {
          adultWeightInput.addEventListener(
            'input',
            function () {
              validateWeightInput(
                adultWeightInput,
                adultWeightContinueButton,
                1,
                100
              );
            }
          );
        }


        if (
          adultWeightContinueButton &&
          adultWeightInput
        ) {
          adultWeightContinueButton.addEventListener(
            'click',
            function () {
              var weight =
                parseWeight(
                  adultWeightInput.value
                );

              if (
                !Number.isFinite(weight) ||
                weight < 1 ||
                weight > 100
              ) {
                return;
              }

              state.expectedAdultWeight =
                weight;

              if (
                state.ageTotalMonths < 12
              ) {
                state.lifeStage =
                  'puppy';

                showCurrentWeightStep(
                  adultWeightStep
                );

                return;
              }

              if (
                state.ageTotalMonths >= 12 &&
                state.ageTotalMonths < 14
              ) {
                if (
                  weight > 30
                ) {
                  state.lifeStage =
                    'puppy';

                  showCurrentWeightStep(
                    adultWeightStep
                  );

                  return;
                }

                state.lifeStage =
                  'adult';

                showIdealWeightStep(
                  adultWeightStep
                );
              }
            }
          );
        }


        if (
          idealWeightInput
        ) {
          idealWeightInput.addEventListener(
            'input',
            function () {
              validateWeightInput(
                idealWeightInput,
                idealWeightContinueButton,
                1,
                100
              );
            }
          );
        }


        if (
          idealWeightContinueButton &&
          idealWeightInput
        ) {
          idealWeightContinueButton.addEventListener(
            'click',
            function () {
              var weight =
                parseWeight(
                  idealWeightInput.value
                );

              if (
                !Number.isFinite(weight) ||
                weight < 1 ||
                weight > 100
              ) {
                return;
              }

              state.idealWeight =
                weight;

              showCurrentWeightStep(
                idealWeightStep
              );
            }
          );
        }


        if (
          currentWeightInput
        ) {
          currentWeightInput.addEventListener(
            'input',
            function () {
              validateWeightInput(
                currentWeightInput,
                currentWeightContinueButton,
                0.5,
                100
              );
            }
          );
        }


        if (
          currentWeightContinueButton &&
          currentWeightInput
        ) {
          currentWeightContinueButton.addEventListener(
            'click',
            function () {
              var weight =
                parseWeight(
                  currentWeightInput.value
                );

              if (
                !Number.isFinite(weight) ||
                weight < 0.5 ||
                weight > 100
              ) {
                return;
              }

              state.currentWeight =
                weight;

              state.currentWeightRange =
                '';

              showBodyConditionStep(
                currentWeightStep
              );
            }
          );
        }


        if (
          currentWeightUnknownButton &&
          currentWeightStep &&
          weightRangeStep
        ) {
          currentWeightUnknownButton.addEventListener(
            'click',
            function () {
              state.currentWeight =
                null;

              showStep(
                currentWeightStep,
                weightRangeStep
              );

              if (
                weightRangeHeading
              ) {
                weightRangeHeading.textContent =
                  'Hvad vejer ' +
                  state.dogName +
                  ' cirka?';
              }
            }
          );
        }


        weightRangeInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  weightRangeContinueButton
                ) {
                  weightRangeContinueButton.disabled =
                    false;
                }
              }
            );
          }
        );


        if (
          weightRangeContinueButton
        ) {
          weightRangeContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-weight-range]:checked'
                );

              if (!selected) {
                return;
              }

              state.currentWeight =
                null;

              state.currentWeightRange =
                selected.value;

              showBodyConditionStep(
                weightRangeStep
              );
            }
          );
        }


        if (
          weightRangeBackButton &&
          weightRangeStep &&
          currentWeightStep
        ) {
          weightRangeBackButton.addEventListener(
            'click',
            function () {
              showStep(
                weightRangeStep,
                currentWeightStep
              );

              if (
                currentWeightInput
              ) {
                currentWeightInput.focus();
              }
            }
          );
        }


        bodyConditionInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  bodyConditionContinueButton
                ) {
                  bodyConditionContinueButton.disabled =
                    false;
                }
              }
            );
          }
        );


        if (
          bodyConditionContinueButton
        ) {
          bodyConditionContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-body-condition]:checked'
                );

              if (!selected) {
                return;
              }

              state.bodyCondition =
                selected.value;

              showWeightLossStep(
                bodyConditionStep
              );
            }
          );
        }


        weightLossInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  weightLossContinueButton
                ) {
                  weightLossContinueButton.disabled =
                    false;
                }
              }
            );
          }
        );


        if (
          weightLossContinueButton
        ) {
          weightLossContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-weight-loss]:checked'
                );

              if (!selected) {
                return;
              }

              state.weightLoss =
                selected.value ===
                'yes';

              showStep(
                weightLossStep,
                neuteredStep
              );

              if (
                neuteredHeading
              ) {
                neuteredHeading.textContent =
                  'Er ' +
                  state.dogName +
                  ' steriliseret eller kastreret?';
              }
            }
          );
        }


        neuteredInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  neuteredContinueButton
                ) {
                  neuteredContinueButton.disabled =
                    false;
                }
              }
            );
          }
        );


        if (
          neuteredContinueButton
        ) {
          neuteredContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-neutered]:checked'
                );

              if (!selected) {
                return;
              }

              state.neutered =
                selected.value === 'yes';

              showStep(
                neuteredStep,
                activityStep
              );

              if (
                activityHeading
              ) {
                activityHeading.textContent =
                  'Hvor aktiv er ' +
                  state.dogName +
                  '?';
              }
            }
          );
        }


        activityInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                state.activity =
                  input.value;
              }
            );
          }
        );


        if (
          activityContinueButton
        ) {
          activityContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-activity]:checked'
                );

              if (!selected) {
                return;
              }

              state.activity =
                selected.value;

              showStep(
                activityStep,
                specialNeedsStep
              );

              if (
                specialNeedsHeading
              ) {
                specialNeedsHeading.textContent =
                  'Har ' +
                  state.dogName +
                  ' særlige behov?';
              }
            }
          );
        }


        specialNeedsInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  input === specialNeedsNone &&
                  input.checked
                ) {
                  specialNeedsInputs.forEach(
                    function (other) {
                      if (
                        other !==
                        specialNeedsNone
                      ) {
                        other.checked =
                          false;
                      }
                    }
                  );
                } else if (
                  input !== specialNeedsNone &&
                  input.checked &&
                  specialNeedsNone
                ) {
                  specialNeedsNone.checked =
                    false;
                }

                validateSpecialNeeds();
              }
            );
          }
        );


        if (
          specialNeedsContinueButton
        ) {
          specialNeedsContinueButton.addEventListener(
            'click',
            function () {
              state.specialNeeds =
                getSelectedValues(
                  root,
                  '[data-fodermatch-special-need]'
                );

              if (
                !state.specialNeeds.length
              ) {
                return;
              }

              showStep(
                specialNeedsStep,
                intolerancesStep
              );

              if (
                intolerancesHeading
              ) {
                intolerancesHeading.textContent =
                  'Er der en ingrediens, ' +
                  state.dogName +
                  ' ikke kan tåle?';
              }
            }
          );
        }


        intoleranceInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  input === intoleranceNone &&
                  input.checked
                ) {
                  intoleranceInputs.forEach(
                    function (other) {
                      if (
                        other !==
                        intoleranceNone
                      ) {
                        other.checked =
                          false;
                      }
                    }
                  );
                } else if (
                  input !== intoleranceNone &&
                  input.checked &&
                  intoleranceNone
                ) {
                  intoleranceNone.checked =
                    false;
                }

                if (
                  intoleranceOtherField &&
                  intoleranceOther
                ) {
                  intoleranceOtherField.hidden =
                    !intoleranceOther.checked;
                }

                validateIntolerances();
              }
            );
          }
        );


        if (
          intoleranceOtherText
        ) {
          intoleranceOtherText.addEventListener(
            'input',
            validateIntolerances
          );
        }


        if (
          intolerancesContinueButton
        ) {
          intolerancesContinueButton.addEventListener(
            'click',
            function () {
              state.intolerances =
                getSelectedValues(
                  root,
                  '[data-fodermatch-intolerance]'
                );

              if (
                !state.intolerances.length
              ) {
                return;
              }

              state.intoleranceOther =
                (
                  intoleranceOther &&
                  intoleranceOther.checked &&
                  intoleranceOtherText
                )
                  ? intoleranceOtherText
                      .value
                      .trim()
                  : '';

              if (
                state.intolerances.indexOf(
                  'other'
                ) !== -1 &&
                !state.intoleranceOther
              ) {
                return;
              }

              showStep(
                intolerancesStep,
                preferenceStep
              );

              if (
                preferenceHeading
              ) {
                preferenceHeading.textContent =
                  'Har ' +
                  state.dogName +
                  ' en præference for en bestemt variant?';
              }
            }
          );
        }


        preferenceInputs.forEach(
          function (input) {
            input.addEventListener(
              'change',
              function () {
                if (
                  preferenceContinueButton
                ) {
                  preferenceContinueButton.disabled =
                    false;
                }
              }
            );
          }
        );


        if (
          preferenceContinueButton
        ) {
          preferenceContinueButton.addEventListener(
            'click',
            function () {
              var selected =
                root.querySelector(
                  '[data-fodermatch-preference]:checked'
                );

              if (!selected) {
                return;
              }

              state.preference =
                selected.value;

              renderResult();
            }
          );
        }
      }
    );
  }


  function startFoderMatch() {
    initFoderMatch(
      document
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startFoderMatch
    );
  } else {
    startFoderMatch();
  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initFoderMatch(
        event.target
      );
    }
  );

})();